export default {"src":"/_next/static/media/GIS.7e0eac98.svg","height":18,"width":18};